import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import {
    RpcExtensionBrokerRequest,
    RpcExtensionBrokerRequestKey
} from './rpc-extension-broker-model';

export class RpcExtensionBrokerRequestClient {
    /**
     * Makes an extension broker request client call.
     *
     * @param data the extension broker request.
     * @return A promise indicating that the request has been sent
     */
    public static extensionBrokerRequest(rpc: Rpc, data: RpcExtensionBrokerRequest, outbound?: RpcOutbound): Promise<void> {
        if (outbound) {
            return RpcOutboundClient.callOutbound(
                rpc.rpcManager.rpcChannel,
                outbound,
                RpcExtensionBrokerRequestKey.command,
                RpcExtensionBrokerRequestKey.version,
                data);
        }

        return RpcInboundClient.call(rpc, RpcExtensionBrokerRequestKey.command, RpcExtensionBrokerRequestKey.version, data);
    }
}
